module.exports = __webpack_public_path__ + "img/active-7.4a34a1ad.svg";